function ContactDetails() {
  return (
    <section className="contact" id="contact">
      <h2>Contact Us</h2>
      <div className="contact-content">
        <div className="contact-info">
          <div className="contact-item">
            <h3>📞 Phone</h3>
            <p>
              Main: +91 9368047013<br />
              Support: +91 9412193600
            </p>
          </div>

          <div className="contact-item">
            <h3>✉️ Email</h3>
            <p>
              Support: support@waschennpure.com
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactDetails;
